import { configurationSettings } from '../../../../configuration';
import { getInProgressItemModifierGroup } from './get-in-progress-item-modifier-group';
export const getAllowedOrderItemModifierQuantity = (modifierGroup, modifierItemId) => {
    const { quantityLimit } = modifierGroup;
    const inProgressItemModifierGroup = getInProgressItemModifierGroup(modifierGroup.id);
    if (!inProgressItemModifierGroup) {
        throw new Error('Cannot get allowed modifier quantity without an inProgressModifierGroup.');
    }
    const { maximumReached: maximumReachedForGroup, selectedQuantity: selectedQuantityForModifierGroup } = inProgressItemModifierGroup;
    const modifierItem = inProgressItemModifierGroup.modifiers.filter(modifier => modifier.itemId === modifierItemId)[0];
    const maxAllowedForModifierGroup = quantityLimit.isUnlimited
        ? configurationSettings.data.order.maximumModifiersPerItem
        : Math.min(quantityLimit.maximum, configurationSettings.data.order.maximumModifiersPerItem);
    const remainingAdditionsForGroup = maximumReachedForGroup
        ? 0
        : maxAllowedForModifierGroup - selectedQuantityForModifierGroup;
    const quantity = {
        max: remainingAdditionsForGroup + modifierItem.quantity,
        selectedQuantity: modifierItem.quantity
    };
    return quantity;
};
